exports.APIS = {
  Commons: {
    AppSetup: "/common/master/get-app-setup",
  },
};
